<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.5 5.5H9.5V34.5H30.5V5.5ZM8 4V36H32V4H8Z"
      class="fill-current"
    />
    <path d="M12 10H23V12H12V10Z" class="fill-current" />
    <path d="M12 14H23V16H12V14Z" class="fill-current" />
    <path d="M12 18H23V20H12V18Z" class="fill-current" />
    <path d="M26 10H28V12H26V10Z" class="fill-current" />
    <path d="M26 14H28V16H26V14Z" class="fill-current" />
    <path d="M26 18H28V20H26V18Z" class="fill-current" />
  </svg>
</template>
